import { Injectable, TemplateRef, Inject } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { BreakpointService } from './breakpoint.service';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';

/* Wrapper for the MatDialog
 * - supports displaying dialogs in full-screen on mobile devices
 */
@Injectable()
export class ApMatDialogService {

  constructor(
    private _dialog: MatDialog,
    private _breakpointService: BreakpointService,
    private scrollStrategryOptions: ScrollStrategyOptions,
    @Inject(DOCUMENT) private document: Document) { }

  open<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D> & { fullscreen?: boolean }): MatDialogRef<T, R> {
    if (!config) {
      config = new MatDialogConfig();
      config.maxWidth = '100vw';
    } else if (!config.maxWidth) {
      config.maxWidth = '100vw';
    }
    if (config != null && config.fullscreen === true) {
      config.width = '100%';
      config.height = '100%';
      this.document.body.classList.add('ap-disable-scroll');
    }

    const dialogRef = this._dialog.open(componentOrTemplateRef, { ...config, scrollStrategy: this.scrollStrategryOptions.block() });

    const handsetSubscription = this._breakpointService.isMobileView
      .subscribe(isMatch => {
        if (isMatch) {
          dialogRef.updateSize('100%', '100%');
        } else {
          dialogRef.updateSize(config.width, config.height);
        }
      });

    dialogRef.afterClosed()
      .subscribe(() => {
        if (config != null && config.fullscreen === true) {
          this.document.body.classList.remove('ap-disable-scroll');
        }

        handsetSubscription.unsubscribe();
      });

    return dialogRef;
  }

}
